// src/components/ShaTelephony/providers/innovaphoneProvider.ts
import { HubConnection } from "@microsoft/signalr";


import {
  ITelephonyProvider,
  // CallDetails,
  LineStatus,
  //TelephonyProviderState,
  CallStatus,
  CallDirection,
  InnovaphoneConfig,
  TelephonyEvent,
  IHttpHeadersDictionary
} from '../models';

import { forEach } from 'lodash';
import { TelephonyBaseProvider } from './telephonyBaseProvider';
import { httpPost } from '../services/httpService';


export class InnovaphoneProvider
  extends TelephonyBaseProvider
  implements ITelephonyProvider {
  public config: InnovaphoneConfig;

  public sessionId: string | null = null;
  private agentId: string | null = null;

  // Login credentials
  private username: string | null = null;
  private password: string | null = null;
  private station: string | null = null;

  // Event callbacks
  // private onIncomingCallRingingCallbacks: ((details: CallDetails) => void)[] = [];
  // private onIncomingCallAnsweredCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutboundCallInitiatedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutboundCallAnsweredCallbacks: ((details: CallDetails) => void)[] = [];
  // private onCallTransferredCallbacks: ((details: CallDetails, phoneNumber: string) => void)[] = [];
  // private onCallEndedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onIncomingCallRejectedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onOutgoingCallRejectedCallbacks: ((details: CallDetails) => void)[] = [];
  // private onAvailabilityChangedCallbacks: ((isAvailable: boolean) => void)[] = [];

  get supportsPopout(): boolean {
    return false;
  }

  get supportsCustomViews(): boolean {
    return false;
  }

  constructor(config: InnovaphoneConfig, connection?: HubConnection, httpHeaders?: IHttpHeadersDictionary) {
    super(connection);
    this.config = config;
    this.httpHeaders = httpHeaders;

    console.log("SignalR constructor");

    console.log("SignalR connection:", this.signalRconnection);
  }

  shouldShowLoginDialog(): boolean {
    return true;
  }

  setSession(sessionId: string): void {
    //disconnect old signalr
    if (this.signalRconnection && this.sessionId) {
      this.signalRconnection.off(
        `TelephonyEvents-${this.sessionId}`,
        this.handleSignalREvents
      );
    }
    if (this.signalRconnection)
      this.signalRconnection.on(
        `TelephonyEvents-${sessionId}`,
        this.handleSignalREvents.bind(this)
      );
    this.sessionId = sessionId;
  }

  release(): void {
    super.release();
    // Disconnect SignalR connection if it exists
    if (this.signalRconnection && this.sessionId) {
      this.signalRconnection.off(
        `TelephonyEvents-${this.sessionId}`,
        this.handleSignalREvents
      );
    }

    // Reset state
    this.state = {
      isLoggedIn: false,
      isAvailable: false,
      status: CallStatus.Idle,
      sessionId: undefined,
      callerNumber: undefined,
      callerName: undefined,
      currentCallId: undefined,
      currentCallDetails: undefined,
      currentCallDirection: undefined,
      recordingId: undefined,
    };
    this.currentCall = null;
  }
  async holdCall(): Promise<void> {
    try {
      console.log("Calling C# Backend: Hold call");
        const response = await this.postWrapper(
        "api/telephony/session/WebAgentSession/hold",
        {
          sessionId: this.sessionId,

        });
      if (response.result === 0) {
        console.log("Call put on hold successfully");
      } else {
        console.error(
          "Failed to hold call:",
          response.error,
          "Code:",
          response.code
        );
      }
    } catch (error) {
      console.error("Error holding call via C# Backend:", error);
    }
  }

  async unholdCall(callId: number): Promise<void> {
    try {
      console.log("Calling C# Backend: Unhold call");
     

       const response = await this.postWrapper(
        "api/telephony/session/WebAgentSession/unhold",
        {
          sessionId: this.sessionId,
          callId
        }
      );
      if (response.result === 0) {
        console.log("Call retrieved from hold successfully");
      } else {
        console.error(
          "Failed to unhold call:",
          response.data.error,
          "Code:",
          response.data.code
        );
      }
    } catch (error) {
      console.error("Error unholding call via C# Backend:", error);
    }
  }

  async muteCall(): Promise<void> {
    try {
      console.log("Calling C# Backend: Mute call");

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/mute',
        {
          sessionId: this.sessionId,
          mute: true,
        }
      );

      if (response) {
        console.log('Call muted via C# Backend');
      } else {
        console.error('Mute failed:', response?.message);
      }
    } catch (error) {
      console.error("Error muting call via C# Backend:", error);
    }
  }

  async unmuteCall(): Promise<void> {
    try {
      console.log("Calling C# Backend: Unmute call");

     const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/unmute',
        {
          sessionId: this.sessionId,
          mute: true,
        }
      );

      if (response) {
        console.log('Call unmuted via C# Backend');
      } else {
        console.error('Unmute failed:', response?.message);
      }
    } catch (error) {
      console.error("Error unmuting call via C# Backend:", error);
    }
  }

  async transferCaller(): Promise<void> {
    try {
      console.log("Calling C# Backend: transfercall");

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/transfercall',
        {
          sessionId: this.sessionId,
        }
      );

      const { result, message, error, code } = response || {};

      if (result === 0) {
        console.log("Call transferred successfully:", message);
      } else {
        console.error("Transfer failed:", error || message, "Code:", code);
      }
    } catch (error) {
      console.error("Error transferring call via C# Backend:", error);
    }
  }

  async postWrapper (url: string, data: any): Promise<any> {

    console.log('this.config.apiBaseUrl', `${this.config.apiBaseUrl}/${url}`);
    try {
      var response = await httpPost(`${this.config.apiBaseUrl}/${url}`, data, this.httpHeaders);
      console.log('postwrapper response', response);
      if (response?.data?.result) {
        return {
          ...response.data.result
        };
      }
    } catch (error) {
      console.error("Error doing post:", error);
      throw error;
    }
    return null;
  };

  async getExistingLogin() {
    try {
      // let user = {
      //   username: Number(this.username),
      // };

      // Check if credentials are set
      if (!this.username) {
        console.error("username not set");
        return false;
      }

      const authenticatedAgent = await this.postWrapper(
        'api/telephony/session/WebAgentSession/getexistingsession',
        {
          username: this.username, // assumes this.username is set
        }
      );

      console.log("authenticatedAgent", authenticatedAgent);

      if (authenticatedAgent) {
        var sessionId = authenticatedAgent.sessionId;
        var agentState = authenticatedAgent.agentState;
        if (!sessionId) {
          console.error("No existing session found");
          return false;
        }

        this.sessionId = sessionId;
        console.log("C# Backend ession exits, sessionId:", this.sessionId);

        //this.signalRconnection.on(`TelephonyEvents`, this.handleSignalREvents.bind(this));

        this.state.isLoggedIn = true;
        this.state.isAvailable = false;

        var isStarted = false;

        if (agentState) {
          switch (agentState) {
            case 0:
              // Stopped
              this.state.status = CallStatus.Idle;
              break;
            case 1:
              // Started
              this.state.status = CallStatus.Idle;
              this.state.isAvailable = true;
              isStarted = true;
              break;
            case 2:
              // Servicing contact
              this.state.status = CallStatus.InCall;
              isStarted = true;
              break;
            case 3:
              // After-call work
              this.state.status = CallStatus.Awaiting;
              this.state.isAvailable = true;
              break;
            case 4:
              // Available
              this.state.status = CallStatus.Idle;
              this.state.isAvailable = true;
              isStarted = true;
              break;
            case 5:
              // Ringing
              //this.state.status = CallStatus.Ringing;
              isStarted = true;
              break;
          }
        }

        this.onLoggedInChangedCallbacks.forEach((cb) =>
          cb(this.state.isLoggedIn)
        );
        this.onAvailabilityChangedCallbacks.forEach((cb) =>
          cb(this.state.isAvailable)
        );

        console.log("Innovaphone session started via C# Backend");
        // return true;
        return {
          result: true,
          session: authenticatedAgent.sessionId,
          isStarted,
        };
      } else {
        console.error('Failed to set station:', authenticatedAgent);
        return false;
      }
    } catch (error) {
      console.error("Innovaphone check session error:", error);
      return false;
    }
  }

  async agentLogin() {
    try {
      let user = {
        username: Number(this.username),
        password: Number(this.password),
        station: Number(this.station),
      };

      // Check if credentials are set
      if (!this.username || !this.password || !this.station) {
        console.error("Login credentials not set");
        return false;
      }

      //let authenticatedAgent = await telephonyAgentLogin(`api/telephony/session/WebAgentSession/login`, user);
      //let authenticatedAgent = await telephonyAgentLogin(`api/innovaphone/login`, user);
       const authenticatedAgent = await this.postWrapper(
        'api/telephony/session/WebAgentSession/login',
        user
      );

      console.log("authenticatedAgent", authenticatedAgent);

      if (authenticatedAgent) {
        this.sessionId = authenticatedAgent.sessionId;
        console.log('C# Backend login successful, sessionId:', this.sessionId);

        this.state.isLoggedIn = true;
        this.state.isAvailable = false;

        console.log("Innovaphone session started via C# Backend");
        this.onLoggedInChangedCallbacks.forEach((cb) =>
          cb(this.state.isLoggedIn)
        );
        this.onAvailabilityChangedCallbacks.forEach((cb) =>
          cb(this.state.isAvailable)
        );
        // return true;
        return { result: true, session: authenticatedAgent.sessionId };
      } else {
        console.error('Failed to set station:', authenticatedAgent);
        return false;
      }
    } catch (error) {
      console.error("Innovaphone login error:", error);
      return false;
    }
  }

  // Set login credentials
  setLoginCredentials(
    username: string,
    password: string,
    station: string
  ): void {
    this.username = username;
    this.password = password;
    this.station = station;
    this.agentId = username;
  }


  private handleSignalREvents(events: [TelephonyEvent]): void {
    console.log("Processing Innovaphone SignalR events:", events);

    forEach(events, (event: TelephonyEvent) => {
      console.log("handing event:", event);
      this.handleSignalREvent(event);
    });
  }

  // Handle SignalR events from C# backend
  private handleSignalREvent(event: TelephonyEvent): void {
    console.log('Processing Innovaphone SignalR event123:', event);

    // if (event.AgentId && event.AgentId !== this.agentId) {
    //   return;
    // }

    switch (event.eventType) {
      //case "AgentStateChanged":
      case 1:
        this.handleAgentStateChanged(event);
        break;
      //case "IncomingCallRinging":
      case 2:
        this.handleIncomingCallRinging(event);
        break;
      case 11:
        this.handleLineStateChange();
        break;
      //case "CallRecorded":
      case 12:
        this.handleCallRecorded(event);
        break;
      // case "CallAnswered":
      //   this.handleCallAnswered(event);
      //   break;
      // case "OutboundCallInitiated":
      //   this.handleOutboundCallInitiated(event);
      //   break;
      // case "CallConnected":
      //   this.handleCallConnected(event);
      //   break;
      // case "CallEnded":
      //   this.handleCallEnded(event);
      //   break;
      // case "CallTransferred":
      //   this.handleCallTransferred(event);
      //   break;
      // case "CallRejected":
      //   this.handleCallRejected(event);
      //   break;
      // case "SessionEnded":
      //   this.handleSessionEnded(event);
      //   break;
      default:
        console.log("Unhandled Innovaphone event type:", event.eventType);
    }
  }

  private handleAgentStateChanged(event: TelephonyEvent): void {
    const oldAvailable = this.state.isAvailable;
    const agentState = event.agentState;
    this.state.isAvailable = agentState === 1;
    console.log("agentState", agentState);
    switch (agentState) {
      case 0:
        // Stopped
        this.state.status = CallStatus.Idle;
        break;
      case 1:
        // Started
        this.state.status = CallStatus.Idle;
        //this.state.isAvailable = true;
        break;
      case 2:
        // Servicing contact
        //this.state.status = CallStatus.InCall;
        break;
      case 3:
        // After-call work
        this.state.status = CallStatus.Awaiting;
        break;
      case 4:
        // Available
        this.state.status = CallStatus.Idle;
        this.state.isAvailable = true;
        break;
      case 5:
        // Ringing
        //this.state.status = CallStatus.Ringing;
        break;
    }

    if (oldAvailable !== this.state.isAvailable) {
      this.onAvailabilityChangedCallbacks.forEach((cb) =>
        cb(this.state.isAvailable)
      );
    }
    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
  }

  private handleIncomingCallRinging(event: TelephonyEvent): void {
    console.log("Incoming call ringing Event:", event);
    this.state.status = CallStatus.Ringing;
    this.state.callerNumber = event.phoneNumber;
    this.state.callerName = "Unknown";
    this.state.currentCallId = "1";
    this.state.currentCallDirection = CallDirection.Inbound;

    const normalizedNumber = this.normalizePhoneForDial(event.phoneNumber, this.config?.defaultCountryCode);

    this.currentCall = {
      id: "1",
      callerNumber: event.phoneNumber,
      callerName: "Unknown",
      direction: CallDirection.Inbound,
      startTime: new Date(),
      numberDetails: normalizedNumber
    };

    this.onIncomingCallRingingCallbacks.forEach((cb) => cb(this.currentCall!));
    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
  }

  private handleLineStateChange(): void {
    this.checkLineStatus().then(async (lineStatus: LineStatus | null) => {
      console.log("linestatus Line status change event:", lineStatus);
      console.log("linestatus Current call:", this.currentCall);
      if (lineStatus && lineStatus.isFree && this.currentCall) {
        // Set end time before firing event
        if (!this.currentCall.endTime) {
          this.currentCall.endTime = new Date();
        }

        this.state.status = CallStatus.Idle;

        // Fire event - base provider will handle persistence
        this.onCallEndedCallbacks.forEach((cb) => cb(this.currentCall!));

        this.currentCall = null; // Clear after event fired
        this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
      } else if (
        lineStatus &&
        lineStatus.isActiveCall &&
        this.state.status === CallStatus.Ringing
      ) {
        //we are now on a call
        this.state.status = CallStatus.InCall;
        this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));

        // Fire the appropriate callback based on call direction
        if (this.currentCall) {
          if (this.currentCall.direction === CallDirection.Outbound) {
            this.onOutboundCallAnsweredCallbacks.forEach((cb) => cb(this.currentCall!));
          } else if (this.currentCall.direction === CallDirection.Inbound) {
            this.onIncomingCallAnsweredCallbacks.forEach((cb) => cb(this.currentCall!));
          }
        }
      }
    });
  }

  private handleCallRecorded(event: TelephonyEvent): void {
    if (event.recordingId && this.currentCall) {
      console.log(`[Innova Recording] Recording ID received: ${event.recordingId}`);
      this.state.recordingId = event.recordingId;
      this.currentCall.recordingId = event.recordingId;
    }
  }

  private resetCallState(): void {
    this.state.status = CallStatus.Idle;
    this.state.callerNumber = undefined;
    this.state.callerName = undefined;
    this.state.currentCallId = undefined;
    this.state.currentCallDirection = undefined;
    this.state.recordingId = undefined;
    this.currentCall = null;
  }

  private setCallStateInClass(): void {
    this.state.status = CallStatus.InCall;
  }

  async login(): Promise<boolean> {
    try {
      if (!this.username || !this.password || !this.station) {
        console.error("Innovaphone login credentials not set");
        return false;
      }

      console.log('Calling C# Backend: api/innovaphone/login');

      const loginResponse = await this.postWrapper('api/innovaphone/login', {
        username: this.username,
        password: this.password,
        station: this.station,
        campaign: this.config.campaign || '',
        skill: this.config.skill || '',
        vdn: this.config.vdn || '',
      });

      if (!loginResponse || !loginResponse?.sessionId) {
        console.error('C# Backend login failed:', loginResponse?.message);
        return false;
      }

      this.sessionId = loginResponse.sessionId;
      console.log('C# Backend login successful, sessionId:', this.sessionId);

      console.log('Calling C# Backend: api/innovaphone/start-session');
      const sessionResponse = await this.postWrapper('api/innovaphone/start-session', {
        agentId: this.agentId,
        station: this.station,
      });

      if (!sessionResponse) {
        console.error('C# Backend start session failed:', sessionResponse?.message);
        await this.cleanup();
        return false;
      }

      this.state.isLoggedIn = true;
      this.state.isAvailable = sessionResponse.isAvailable || false;

      console.log("Innovaphone session started via C# Backend");
      return true;
    } catch (error) {
      console.error("Innovaphone login error:", error);
      await this.cleanup();
      return false;
    }
  }

  async logout(): Promise<boolean> {
    try {
      console.log('Calling C# Backend: api/innovaphone/logout');

      if (this.sessionId) {
        await this.postWrapper(
          'api/telephony/session/WebAgentSession/logout',
          {
            agentId: this.agentId,
            sessionId: this.sessionId,
          }
        );
      }
      this.state.isLoggedIn = false;
      this.onLoggedInChangedCallbacks.forEach((cb) =>
        cb(this.state.isLoggedIn)
      );

      await this.cleanup();
      console.log("Innovaphone logout completed via C# Backend");
      return true;
    } catch (error) {
      console.error("Innovaphone logout error:", error);
      await this.cleanup();
      return false;
    }
  }

  async stopSession(): Promise<boolean> {
    try {
      console.log('Calling C# Backend: stop session');

      if (this.sessionId) {
        await this.postWrapper(
          'api/telephony/session/WebAgentSession/stop',
          { agentId: this.agentId }
        );
      }

      console.log('Innovaphone session stop');
      return true;
    } catch (error) {
      console.error("Innovaphone session end error:", error);
      return false;
    }
  }

    private async cleanup(): Promise<void> {
    //await stopSignalR();
    this.signalRconnection.off(
      "TelephonyEvents",
      this.handleSignalREvents.bind(this)
    );
    this.state.isLoggedIn = false;
    this.state.isAvailable = false;
    this.state.status = CallStatus.Idle;
    this.state.recordingId = undefined;
    this.currentCall = null;
    this.sessionId = null;
  }

  async setOnBreak(): Promise<void> {
    await this.setOnBreakWithReason(20);
  }

  async setOnBreakWithReason(reasonCode: number): Promise<boolean> {
    try {
      console.log('Calling C# Backend: api/innovaphone/set-break');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/stop',
        {
          agentId: this.agentId,
          reasonCode: reasonCode,
          sessionId: this.sessionId,
        }
      );

      if (response) {
        this.state.isAvailable = false;
        this.onAvailabilityChangedCallbacks.forEach((cb) => cb(false));
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error setting break via C# Backend:", error);
      return false;
    }
  }

  async setAvailable(): Promise<void> {
    try {
      console.log('Calling C# Backend: api/telephony/session/WebAgentSession/start');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/start',
        { sessionId: this.sessionId }
      );

      if (response) {
        this.state.isAvailable = true;
        this.onAvailabilityChangedCallbacks.forEach((cb) => cb(true));
      }
    } catch (error) {
      console.error("Error setting available via C# Backend:", error);
    }
  }

  async endShift(reasonCode: number = 50): Promise<boolean> {
    try {
      console.log('Calling C# Backend: api/innovaphone/end-shift');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/stop',
        {
          agentId: this.agentId,
          reasonCode: reasonCode,
          sessionId: this.sessionId,
        }
      );

      if (response) {
        this.state.isAvailable = false;
        this.onAvailabilityChangedCallbacks.forEach((cb) => cb(false));
        console.log("Shift ended via C# Backend");
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error ending shift via C# Backend:", error);
      return false;
    }
  }

  async dial(number: string): Promise<void> {
    try {
      console.log('Calling C# Backend: api/innovaphone/make-call');
      console.log('Dialing number:', number);

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/makecall',
        {
          agentId: this.agentId,
          phoneNumber: number,
          appData: `Outbound call to ${number}`,
          sessionId: this.sessionId,
          isExternal: number && number.length >= 7 ? true : false,
        }
      );

      if (response) {
        console.log('Call initiated via C# Backend:', response.callId);

        this.state.status = CallStatus.Ringing;
        this.state.callerNumber = number;
        this.state.currentCallId = response.callId;
        this.state.currentCallDirection = CallDirection.Outbound;

        const normalizedNumber = this.normalizePhoneForDial(number, this.config?.defaultCountryCode);
        //console.log('Innvo normalizedNumber on dial', normalizedNumber)

        this.currentCall = {
          id: response.callId,
          callerNumber: number,
          direction: CallDirection.Outbound,
          startTime: new Date(),
          numberDetails: normalizedNumber
        };

        this.onOutboundCallInitiatedCallbacks.forEach((cb) =>
          cb(this.currentCall)
        );
        this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
      } else {
        console.error('Call failed via C# Backend:', response?.message);
      }
    } catch (error) {
      console.error("Error dialing via C# Backend:", error);
    }
  }

  async answerCall(): Promise<void> {
    try {
      console.log('Calling C# Backend: api/innovaphone/answer-call');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/answercall',
        { sessionId: this.sessionId }
      );

      this.setCallStateInClass();
      this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
      this.onIncomingCallAnsweredCallbacks.forEach((cb) =>
        cb(this.currentCall!)
      );

      if (response) {
        console.log('Call answered via C# Backend');
      }
    } catch (error) {
      console.error("Error answering call via C# Backend:", error);
    }
  }

  async rejectCall(): Promise<void> {
    try {
      console.log('Calling C# Backend: api/innovaphone/reject-call');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/clearcall',
        { sessionId: this.sessionId }
      );

      if (response) {
        console.log('Call rejected via C# Backend');
      }
    } catch (error) {
      console.error("Error rejecting call via C# Backend:", error);
    }
    this.resetCallState();
    this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));
    this.onIncomingCallRejectedCallbacks.forEach((cb) => cb(this.currentCall!));
  }

  async endCall(): Promise<void> {
    try {
      console.log('Calling C# Backend: api/innovaphone/end-call');

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/clearcall',
        { sessionId: this.sessionId }
      );

      // Set end time and fire event - base provider will handle persistence
      if (this.currentCall) {
        console.log('[Innova Call Ended] Call details:', {
          callId: this.currentCall.id,
          recordingId: this.currentCall.recordingId,
          callerNumber: this.currentCall.callerNumber,
          direction: this.currentCall.direction
        });

        if (!this.currentCall.endTime) {
          this.currentCall.endTime = new Date();
        }

        // Fire event before reset
        this.onCallEndedCallbacks.forEach((cb) => cb(this.currentCall!));
      }

      this.resetCallState();
      this.onStatusChangedCallbacks.forEach((cb) => cb(this.state.status));

      if (response) {
        console.log('Call ended via C# Backend');
      }
    } catch (error) {
      console.error("Error ending call via C# Backend:", error);
    }
  }

  async transferCall(phoneNumber: string, isAgent: boolean): Promise<void> {
    try {
      console.log('Calling C# Backend: api/telephony/session/WebAgentSession/directtransfercall');
      console.log('Transfer target:', phoneNumber, 'isAgent:', isAgent);
      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/directtransfercall',
        {
          agentId: this.agentId,
          phoneNumber: phoneNumber,
          isExternal: phoneNumber && phoneNumber.length >= 7 ? true : false,
          sessionId: this.sessionId,
        }
      );

      if (response) {
        // Set end time and fire call ended event (transfer ends the call for this agent)
        if (this.currentCall && !this.currentCall.endTime) {
          this.currentCall.endTime = new Date();
        }

        this.onCallTransferredCallbacks.forEach((cb) => cb(this.currentCall!, phoneNumber));

        // Fire call ended to persist the log
        if (this.currentCall) {
          this.onCallEndedCallbacks.forEach((cb) => cb(this.currentCall!));
        }

        this.handleLineStateChange();
      } else {
        console.error('Transfer failed via C# Backend:');
      }
    } catch (error) {
      console.error("Error transferring call via C# Backend:", error);
    }
  }

  async setCallQCode(qCode: number): Promise<void> {
    try {
      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/setQCode',
        {
          sessionId: this.sessionId,
          qCode: qCode,
        }
      );

      if (response) {
        // C# backend will send SignalR event for state update
      }
    } catch (error) {
      console.error("Error settingQCode call via C# Backend:", error);
    }
    this.resetCallState();
  }

  async finaliseCall(): Promise<void> {
    try {
      await this.setCallQCode(100);

      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/closeContact',
        {
          sessionId: this.sessionId,
          qCode: 50,
        }
      );

      if (response) {
        // C# backend will send SignalR event for state update
      }
    } catch (error) {
      console.error("Error rejecting call via C# Backend:", error);
    }
  }

  async checkLineStatus(): Promise<LineStatus | null> {
    try {
      const response = await this.postWrapper(
        'api/telephony/session/WebAgentSession/getlines',
        { sessionId: this.sessionId }
      );

      return response;
    } catch (error) {
      console.error("Error rejecting call via C# Backend:", error);
      return null;
    }
  }
}
